"use client";
import {
  HovercardContextProvider
} from "../__chunks/ZPKRQJBS.js";
import "../__chunks/URSEQETI.js";
import "../__chunks/J7UNXP2A.js";
import "../__chunks/SJ5YBTFK.js";
import "../__chunks/YIF72NQG.js";
import {
  useHovercardStore
} from "../__chunks/IOEKCBMU.js";
import "../__chunks/GO53B7AR.js";
import "../__chunks/X5ETRS5D.js";
import "../__chunks/5UDX7WKK.js";
import "../__chunks/DTNGDFNU.js";
import "../__chunks/OPTPHWV7.js";
import "../__chunks/4ROCFRIN.js";
import "../__chunks/4R3V3JGP.js";

// src/hovercard/hovercard-provider.tsx
import { jsx } from "react/jsx-runtime";
function HovercardProvider(props = {}) {
  const store = useHovercardStore(props);
  return /* @__PURE__ */ jsx(HovercardContextProvider, { value: store, children: props.children });
}
export {
  HovercardProvider
};
